<template>
  <div class="box">
    <section class="nav_bg" v-if="imgs.length>0"></section>
    <section class="swiper_box" v-if="imgs.length>0">
      <swiper-component :imgs="imgs" :cclass="swiper_h" ref="indexSwiper" ></swiper-component>
      
    </section>
    <div  v-if="$store.state.common.theme==3"  class="pagination">
     
         <span v-for="(item,index) in imgs" :key="index" :class="index==activeIndex?'pagination_active':'pagination_item'" ></span>

    </div>
    <div :class="['icons',pages[0] && pages[0].length<=4?'icons_l':'', $store.state.common.theme==3 ?'icons_b':''  ]">
      <swiper v-if="$store.state.common.theme!=3"  :show-indicators="false">
        <swiper-slide class="swiper_item" v-for="(page,index) of pages" :key="index">
          <div @click="toPage(item)" class="icon" v-for="(item,i) of page" :key="item.desc">
            <img
              v-if="common.holidayStyle>0 &&(page.length>=10 ||page.length==5 )"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
            />
            <img
              v-else-if="common.holidayStyle>0 && page.length<5"
               class="icon_img_content"
            
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i<5)"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length!=6"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <img
              v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length==6"
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_10.png`)"
            />
            <img
              v-else
              class="icon_img_content"
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            <p class="icon_desc">{{item.text}}</p>
          </div>
        </swiper-slide>
      </swiper>
      <swiper v-else :show-indicators="false">
        <swiper-slide class="swiper_item" v-for="(page,index) of pages" :key="index">
          <div @click="toPage(item)" class="icon" v-for="(item,i) of page" :key="item.desc">
            <div   v-if="common.holidayStyle>0 &&(page.length>=10 ||page.length==5 )"
              class="icon_img_content1">
              <img
              
                :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
              />
            </div>
            <div  v-else-if="common.holidayStyle>0 && page.length<5"
              class="icon_img_content1">
              <img
               
                :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
              />
            </div>
            <div   v-else-if="common.holidayStyle>0 &&(i<5)"
              class="icon_img_content1">
              <img
              
                :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_${i}.png`)"
              />
            </div>
            <div  v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length!=6"
              class="icon_img_content1">
            <img
             
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
            </div>
            <div  v-else-if="common.holidayStyle>0 &&(i>=5) &&page.length==6"
              class="icon_img_content1">
            <img
             
              :src="require(`../../../assets/images/tabicon/holiday_${common.holidayStyle}/tabicon_10.png`)"
            />
          </div>
          <div  v-else-if="item.url=='icon_more.png'" class="icon_img_content_more">
            <img
            
              :src="require(`../../../assets/images/tabicon/tabicon_${4}/${item.url}`)"
            />
            
          </div>
          <div   v-else
            class="icon_img_content1">
            <img
            
              :src="require(`../../../assets/images/tabicon/tabicon_${iconStyle}/${item.url}`)"
            />
          </div>
            <p class="icon_desc">{{item.text}}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import swiperComponent from '../../../components/swiper'
import util from '../../../utils/util'
import {
  getPermissionByUserId,
  getIntServTemplateByMarketId,
  getTenantBuildList,
  getOfficeMaterialListByMarketId,
  getPerssionCompanyList,
  loadParkHeaderById,
  getVisitorRegByParams,getYoGoPathByMarketId,updateOpenYoGo
} from '../../../utils/api'
export default {
  name: "indexIcons",
  components: {
    swiperComponent
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    iconStyle: {
      type: Number,
      default: 0
    },
    imgs: {
      type: Array,
      default() {
        return [];
      }
    },
    common: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      timeout: null,
      activeIndex: 0,
      // options:{
      //   pagination: ".swiper-pagination",
      //     paginationType: "fraction",
      //     // paginationType: "bullets",
      //     autoplayDisableOnInteraction : false,
      //     autoplay: 3000,
      //     speed: 1000,
      //     loop:false
      // }
    }
  },
  computed: {
    pages() {
      const pages = [];
      let newList = this.list.filter(item => {
        return item.show;
      });
      newList.forEach((item, index) => {
        const page = Math.floor(index / 10);
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
      });
      return pages;
    },
    //  activeIndex(){
    //   if(this.$refs.indexSwiper){
    //     return this.$refs.indexSwiper.$refs.componentsSwiper.swiper.activeIndex
    //   }else{
    //     return 0
    //   }
    // }
  },
  created() {
    if(this.common.theme ==3){
      // this.options.paginationType = "bullets";
        var that =this 
        that.timeout =setInterval(() => {
          if(that.$refs.indexSwiper){
            that.activeIndex =  that.$refs.indexSwiper.$refs.componentsSwiper.swiper.activeIndex
        }else{
          that.activeIndex =0
        }
        
      }, 1000);
    }
    console.log("in index-nav   "  + JSON.stringify(this.iconStyle))
  },
  beforeDestroy(){
    if(this.timeout){
       clearInterval(this.timeout)
       this.timeout =''
    }
  },
  methods: {
    toPage(val) {
      // console.log("in swiper.activeIndex   "  + this.$refs.indexSwiper.$refs.componentsSwiper.swiper.activeIndex)
      console.log("in activeIndex   "  + this.activeIndex)
      console.log("in toPage   "  + JSON.stringify(val))
      if (val.text === '全部') {
        this.$router.push("/allModule")
        return;
      }
      if (val.link) {
        if (
          !this.$store.state.common.userId &&
          val.link.indexOf('emptyShopList') == -1 &&
          val.link.indexOf('BusinessLife') == -1 &&
          val.link.indexOf('policyServices') == -1 &&
          val.link.indexOf('officeService') == -1 &&
          val.link.indexOf('accessControl') == -1 &&
          val.link.indexOf('hpRecharge') == -1 &&
          val.link.indexOf('meetingRoom') == -1 &&
          val.link.indexOf('parkingService') == -1
        ) {
          console.log("no userId   "  )
          this.$router.push({
            path: '/login',
            // query:{
            //   Rurl:`${val.link}`
            // }
          });
        } else {
          console.log('isOtherPath ===  ' + val.isOtherPath)
          console.log('link =====' +  val.link)
          if (val.link.indexOf("http:") > -1 || val.link.indexOf("https:") > -1) {
            // 跳转网页地址
            // if(val.link.indexOf("wxaurl") > -1){ //打开小程序
            if(val.isOtherPath)  {
              window.location.href =  val.link
            }else{ //iframe
              localStorage.setItem("src", val)
              this.$router.push(`/iframePage`)

            }

            // localStorage.setItem("src", val)
            // this.$router.push(`/iframePage`)
          } else if(val.link.indexOf("weixin:") > -1 ){   //weixin://dl/business/?t=hLfqQ4idb1o 
             window.location.href = val.link
          }else if(val.isOtherPath)  {
              window.location.href =  val.link
          }else {
            if (val.link == '/comReporting') {// 企业报表
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REPORT") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/bill') { //在线账单
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("BILL") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/revenueIndex') { //营收填报
              getPermissionByUserId({ marketId: this.common.marketInfo.id, userId: this.common.userId }).then(res => {
                console.log(res)
                if (res.res.code === 10000 && res.body) {
                  if (res.body.permission && res.body.permission.indexOf("REVENUE") > -1) {
                    this.$router.push(val.link);
                  } else {
                    util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                  }
                }
              })
            } else if (val.link == '/houseKeeping') { //家政服务
              getIntServTemplateByMarketId({}).then(res => {
                console.log(res);
                if (res.res.code === 10000 && res.body && res.body.intServTemplate) {
                  if (res.body.intServTemplate.length > 1) {
                    var link1 = '/houseHomePage'
                    this.$router.push(link1);
                  } else {
                    this.$router.push(val.link);
                  }
                } else {
                  util.showModal('', '项目暂未开启服务', false, '知道了', () => {

                  })
                }
              });
            } else if (val.link == '/accessControl') {
              getTenantBuildList({ 'userId': this.common.userId, 'marketId': this.common.marketInfo.id }).then(res => {
                if (res.res.code === 10000) {
                  this.$router.push(val.link);
                } else {
                  var msg = "您还没有可以使用的门禁";
                  if (res.res.msg) {
                    msg = res.res.msg;
                  }
                  if(res.code != 10004){
                     util.showModal('', msg, false, '知道了', () => { })
                  }
                }
              });
            } else if (val.link == '/hpRecharge') {
              console.log("in hpRecharge")
              var params={
                 perssionVal: "RECHARGE",
                 marketId: this.common.marketInfo.id,
                 companyId:this.common.userTenantInfo.companyId,

                 userId:this.common.userId
              }
              getPerssionCompanyList(params).then(res => {
                if (res.res.code === 10000) {
                    console.log("RECHARGE")
                     var list = res.body.companyList
                    var item =''
                    for(var i=0;i<list.length;i++){
                      if(list[i].isDeafult){
                        item = list[i]
                        break;
                      }
                    }
                    if(item){
                      var url = '/hpRecharge' + '?companyId=' + item.companyId
                      this.$router.push(url);

                    }else{
                      this.$router.push(val.link);
                    }
                  }else{
                    if(res.code != 10004){
                      util.showToast(res.res.msg)
                    }
                  }
              })
             } else if (val.serverPath == '/parkingCoupon') { //停车券
                  var params={
                    perssionVal: "PARKINGCOUPON",
                    marketId: this.common.marketInfo.id,
                    companyId:this.common.userTenantInfo.companyId,
                    userId:this.common.userId
                  }
                  getPerssionCompanyList(params).then(res => {
                      if (res.res.code === 10000) {
                        console.log("PARKINGCOUPON")
                        this.$router.push(val.serverPath);
                      }else{
                        if(res.res.code != 10004){
                          // util.showToast(res.res.msg)
                          util.showModal('您还没有权限', '请联系企业管理员获取更多权限', false, '知道了')
                        }
                      }
                  })


            } else if (val.link == '/officeService') {//办公耗材
              getOfficeMaterialListByMarketId({}).then(res => {
                if (res.res.code === 10000 && res.body && res.body.tbOfficeMaterials && res.body.tbOfficeMaterials.length > 0) {
                  this.$router.push(val.link + '?pageTitle=' +val.text);
                } else {
                  util.showModal('', '项目暂未开启服务', false, '知道了')
                }
              })
            } else if (val.link == '/parking') {//月租车
              util.showLoading()
              loadParkHeaderById({ subProjectId: this.common.marketInfo.id, url: "/parking/rstParkHeader/queryParkHeaderList" }).then(res => {
                util.hideLoading()
                if (res.res && res.res.code === 10000 && res.body && res.body.data && res.body.data.length > 0) {
                  this.$router.push(val.link);
                } else if (res.res.code !== 10004) {
                  util.showModal('', '项目暂未开启服务', false, '知道了')
                }
              })
            } else if (val.link == '/fanke') {//访客
              getVisitorRegByParams({
                userId: this.common.userId,
                marketId: this.common.marketInfo.id
              }).then(res => {
                if (res.res && res.res.code === 10003 && res.body) {
                  util.showModal(res.body.title, res.body.desc, false, '知道了')
                } else {
                  this.$router.push(val.link + '?pageTitle=' +val.text) ;
                }
              })
            } else if (val.link == '/wuyeRepair') {//物业保修
                var that =this
                var link = val.link
                if(that.common.marketInfo.id && that.common.cityId){
                    link  = link + '?marketId=' + that.common.marketInfo.id + '&cityId=' + that.common.cityId
                }else if(that.common.marketInfo.id && !that.common.cityId){
                    link = link + '?marketId=' + that.common.marketInfo.id
                }else if(!that.common.marketInfo.id && that.common.cityId){
                    link = link + '?cityId=' + that.common.cityId
                }
                this.$router.push(link);
            } else if(val.link == '/robot') { //机器人
              if(!this.common.userTenantInfo.id){
                util.showToast('未认证无法使用机器人')
              } else if(!this.common.userTenantInfo.openYogo) {
                util.showModal('授权提醒','即将离开租客服务，打开送餐机器人页面', true, '确定', () => {
                  this.getYoGoPathByMarketId()
                  updateOpenYoGo({
                    tenantId: this.common.userTenantInfo.id,
                    openYogo: 1
                  })
                })
              } else{
                this.getYoGoPathByMarketId()
              }
            } else {
              console.log("in other" + val.link)
              this.$router.push(val.link);
            }
          }
        }
      } else {
        util.showToast('敬请期待')
      }
    },
    getYoGoPathByMarketId() {
      getYoGoPathByMarketId({
            tenantId: this.common.userTenantInfo.id
          }).then(res => {
            if(res.res.code == 10000){
              window.location = res.body.url
            } else {
              util.showToast('获取机器人地址失败')
            }
          })
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.swiper_box {
  height: 306px;
  padding: 0 28px;
  background-color: #f8f8f8;
  width: 100%;
  box-sizing: border-box;
  
}
.pagination{
  width: 100%;
  height:50px;
  background-color: #f8f8f8;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination_item{
  display: flex;
  width: 12px;
  height: 8px;
  border-radius: 4px;
  margin-right: 28px;
  background-color: #FFFFFF;
}
.pagination_active{
  display: flex;
  width: 24px;
  height: 8px;
  border-radius: 4px;
  margin-right: 28px;
  background-color: #c9a779;
}
.icons {
  // height: 3.64rem;
  padding-bottom: 28px;
  background: #fff;
}
.icons_l {
  height: 1.96rem;
}
.icons_b{
  width: 710px;
  margin-left: 20px;
  border:1px solid #c9a779;
}
.swiper_item {
  .flex();
  width: 100%;
  height: 100%;
}
.icon {
  .flex();
  flex-direction: column;
  align-items: center;
  width: 20%;
  text-align: center;
  margin-top: 28px;

  .icon_img_content{
    display: block;
    width: 1rem;
    height: 1rem;
    margin-bottom: 0.06rem;
  }
  .icon_img_content1 {
    display: block;
    width: 1rem;
    height: 1rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   
 
    margin-bottom: 0.06rem;
    border-radius: 50%;
     border:1px solid #c9a779;
    img{
      margin-left: 12.5%;
      margin-top: 12.5%;
      display:flex;
      width: 75%;
      height: 75%;
     }
  }
  .icon_img_content_more {
    display: block;
    width: 1rem;
    height: 1rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
   
 
    margin-bottom: 0.06rem;
    border-radius: 50%;
    
    img{
     
      display:flex;
      width:100%;
      height: 100%;
     }
  }
  .icon_desc {
    height: 0.34rem;
    font-size: 0.24rem;
    color: #333;
    line-height: 0.34rem;
    .textOver(100%);
  }
}
</style>
